export function stepTitle(step, catalog) {
  return step.name || catalog.labels.unnamed;
}

export function stepDetail(step, catalog) {
  if (step.mode === 'script') return step.command || bundleName(step.bundles[0]?.bundleId, catalog) || '';
  if (step.mode === 'workflow') return callableWorkflow(step.childWorkflowId, catalog)?.name ?? '';

  return credentialLabel(step.credentialId, catalog.credentials);
}

export function credentialLabel(id, credentials) {
  const found = credentials.find((candidate) => candidate.id === id);

  return found ? `${found.provider} · ${found.name}` : '';
}

export function triggerFace(trigger, catalog) {
  const labels = catalog.labels.triggerCard[trigger.kind];
  const name = trigger.name.trim();
  const chosen = trigger.kind === 'webhook' ? webhookSlug(trigger.webhookId, catalog) : trigger.cron;
  const parts = name ? [chosen] : [];

  if (trigger.kind === 'webhook') parts.push(trigger.events.trim());

  return {
    title: name || chosen || labels.blank,
    detail: parts.filter(Boolean).join(' · ') || labels.detail,
    named: Boolean(name),
  };
}

export function callableWorkflow(id, catalog) {
  return catalog.workflows.find((candidate) => candidate.id === id) ?? null;
}

function webhookSlug(id, catalog) {
  return catalog.webhooks.find((webhook) => webhook.id === id)?.slug ?? '';
}

function bundleName(id, catalog) {
  return catalog.bundles.find((bundle) => bundle.id === id)?.name ?? null;
}
